import getCurrentBrand from "./utils/getCurrentBrand";

/**
 * Based on the current brand, returns one of the given value. The first value
 * is treated as the default value.
 *
 * @param valentino
 * @param red
 * @returns {*}
 */
function branding(valentino, red) {
  try {
    if (getCurrentBrand() === 'red') {
      return red;
    }

    return valentino;
  } catch (e) {
    return valentino
  }
}

const theme = {
  fontFamilyHeading: branding("Din, sans-serif", "'Bebas Neue', Arial, sans-serif"),
  fontFamilyHeadingLetterSpacing: branding(['.021875rem', null], [null, '.0625rem']),

  fontFamily: branding("Din, sans-serif", "'Source Sans Pro', sans-serif"),
  fontFamilyLetterSpacing: branding(['.021875rem', null], [null, null]),

  accentColor: branding('#000', '#cb9190'),
  accentColorBright: branding('#f400a1', '#cb9190'),

  primaryBackgroundColor: branding('#fff', '#f8f4f3'),
  primaryBackgroundColorNegative: branding('#333', '#f8f4f3'),
  secondaryBackgroundColor: branding('#000', '#000'),
  secondaryBackgroundColorNegative: branding('#fff', '#ecd3cf'),
  tertiaryBackgroundColor: branding('#000', '#cb9190'),
  tertiaryBackgroundColorNegative: branding('#252525', '#777777'),

  primaryIconColor: branding('#000', '#000'),
  secondaryIconColor: branding('#fff', '#fff'),

  homeDiscoverAlsoContentId: {
    timeless: branding('VB12I8F@e9737563-e1cf-4e6d-833b-a39b55a650c6', 'kxrxp1@b722404a-ed0a-4212-9214-b5935325d648'),
    glossary: branding('VB12I8F@73c62073-ab71-4857-bd3f-d30ac1574380', 'kxrxp1@ec8b9462-50ef-4e96-bebf-48829ca44bcd'),
    merchandisingManuals: branding('VB12I8F@35b94243-ab10-46d5-a085-5eb04365a623', 'kxrxp1@ed7324b3-e071-47ad-8708-d747da7f90ca'),
    productFocus: branding('VB12I8F@d0317120-bf04-456e-a38b-2a19ac631c11', null),
  },
  pageHeaderContentId: {
    archive: branding('VB12I8F@68ddc90c-9538-4649-85b9-29b993848d2f', 'kxrxp1@5fe1970e-4b97-4221-87b7-ee74a9ab7339'),
    profile: branding('VB12I8F@1649b3a9-f31e-4b6e-a8aa-448bde691d92', 'kxrxp1@ecd60969-a696-4668-81f8-92aada8abcbe'),
    glossary: branding('VB12I8F@6c903584-92ca-41d2-912e-c5e68ce4810b', 'kxrxp1@7a3b178f-826a-4575-bb41-339b31abae2f'),
    reports: branding('VB12I8F@1ed22c95-ee2c-4180-a49c-92773812ad15', 'kxrxp1@e7a082e2-a4c6-4fe4-8c13-3a561457cb3b'),
  },
  miscContentId: {
    loginMobile: branding('VB12I8F@54743844-fcba-4a6c-8263-2842e86909e7', 'kxrxp1@e34da78c-bcf1-4180-95fd-4382db454498'),
    loginTablet: branding('VB12I8F@ccf288ae-7653-4ebe-bc65-676a0ed61bdd', 'kxrxp1@e34da78c-bcf1-4180-95fd-4382db454498'),
    collectionFirstTheme: branding('VB12I8F@016c0381-c8ee-48a3-b679-58cf779813bb', 'kxrxp1@f8eabcc1-ef50-4993-8f12-1c568b79c346'),
  },
};

export default theme;
